import '../App.css';
import Document from './HighlightDocument';
import MainToolbar from './HighlightMainToolbar';
import {defaultTheme, Provider, Flex, Button, AlertDialog, DialogTrigger } from '@adobe/react-spectrum';
import { useEffect, useState } from 'react';
import { logHighlightedPassage } from '../logging';

function HighlightingInterface({participantId, maxWordCount, passage, constrainHighlights, callbacks}) {
  // TOOLBAR
  const [selectedTool, setSelectedTool] = useState("highlighter"); // current tool selected

  // WORD COUNT
  const [wordCount, setWordCount] = useState(0);
  const [progressWordCount, setProgressWordCount] = useState(0);
  const [shadowWordCount, setShadowWordCount] = useState(0);
  
  // HIGHLIGHTS
  const [highlights, setHighlights] = useState([]); // all of the raw selections
  const [markToTarget, setMarkToTarget] = useState({}); // which mark to target on click
  const [allowedToHighlight, setAllowedToHighlight] = useState(true); // whether the user is allowed to highlight

  const [showError, setShowError] = useState(false); // whether the error message is shown

  // update the progress bars whenever the word count changes
  useEffect(() => {
    if (constrainHighlights) {
      setProgressWordCount(wordCount);
      setShadowWordCount(wordCount);

      // if the user has reached the max word count, disable highlighting
      if (wordCount > maxWordCount) {
        setAllowedToHighlight(false);
        setShowError(true);
      }
      else if (wordCount === maxWordCount) {
        setAllowedToHighlight(false);
        setShowError(false);
      }
      else {
        setAllowedToHighlight(true);
        setShowError(false);
      }
    }

  }, [wordCount]);

  function countNumWords(newSelection){
    // remove empty strings and punctuation
    var words = [];
    var punctuations = [".", ",", ":", "!", "?", "-", "(", ")", "[", "]", "{", "}", ";", "'", '"', "<", ">", "/", "\\"];
    newSelection.split(" ").forEach(element => {
        // check if the element is not empty and not a punctuation
        if (element !== "" && !punctuations.includes(element)){
            words.push(element);
        }
    });
    
    return words.length;
  }

  function finishReading() {
    logHighlightedPassage({participantId, highlights}, callbacks);
  }

  return (
    <div style={{backgroundColor: "#f8f8f8"}}>
      <Provider theme={defaultTheme} colorScheme='light'>
        <Flex direction="column" justifyContent={'start'} gap="2000px">
          <MainToolbar 
            setSelectedTool={setSelectedTool}
            wordCount={wordCount}
            showError={showError}
            progressCount={progressWordCount}
            shadowCount={shadowWordCount}
            maxWordCount={maxWordCount} 
            constrainHighlights={constrainHighlights}
            />

          <Flex direction="row" justifyContent={'center'}>
            <Document
              countNumWords={countNumWords}       
              passage={passage}
              allowedToHighlight={allowedToHighlight}
              setAllowedToHighlight={setAllowedToHighlight}
              highlights={highlights}
              setHighlights={setHighlights}
              selectedTool={selectedTool}
              wordCount={wordCount}
              setWordCount={setWordCount}
              setProgressWordCount={setProgressWordCount}
              setShadowWordCount={setShadowWordCount}
              maxWordCount={maxWordCount}
              markToTarget={markToTarget}
              setMarkToTarget={setMarkToTarget}
              showError={showError}
              setShowError={setShowError}
              constrainHighlights={constrainHighlights}
              participantId={participantId}
               />
          </Flex>
        </Flex>

        <DialogTrigger>
          <Button variant='primary' style='fill' position='fixed' bottom='size-50' right='size-300'>Finish Reading</Button>
          <AlertDialog
            variant="confirmation"
            title="Are you sure you want to finish reading?"
            primaryActionLabel="Finish Reading"
            cancelLabel="Cancel"
            autoFocusButton="primary"
            onPrimaryAction={finishReading}       
            >
            If you have finished reading, you will be asked to answer a few questions about your experience.

          </AlertDialog>
        </DialogTrigger>
      </Provider>
    </div>
  );
}

export default HighlightingInterface;